import React, { Component, Fragment } from 'react';
import { NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import { translate } from '../../translations/translator_utils';

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            userName: null
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            userName: user && user.name
        });
    }

    render() {
        const { isAuthenticated, userName } = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            return this.authenticatedView(userName, profilePath, logoutPath);
        }
    }

    authenticatedView(userName, profilePath, logoutPath) {
        return (
            <Fragment>
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav className="navbarAvatar">
                        <img src={sessionStorage.getItem("avatar")} />
                    </DropdownToggle>
                    <DropdownMenu right className="navBarAvatarDropdownMenu">
                        <DropdownItem tag={Link} to={"/profile/" + sessionStorage.getItem("current_user_id")}>
                            {translate('generic.navbar.my_profile')}
                        </DropdownItem>
                        <DropdownItem tag={Link} to={"/editProfile"}>
                            {translate('generic.navbar.account_settings')}
                        </DropdownItem>
                        <DropdownItem tag={Link} to={'/'}>
                            {translate('generic.navbar.help')}
                        </DropdownItem>
                        <DropdownItem tag={Link} to={logoutPath}>
                            {translate('generic.navbar.logout')}
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>                
            </Fragment>
        );
    }

    anonymousView(registerPath, loginPath) {
        return (<Fragment>
            <NavItem>
                <NavLink tag={Link} className="text-light" to={registerPath}>Register</NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={Link} className="text-light" to={loginPath}>Login</NavLink>
            </NavItem>
        </Fragment>);
    }
}
